import { useMemo } from 'react'
import useScreenSize from '../../hooks/useScreenSize'
import { useExperimentManager } from '../../services/ExperimentManager/ExperimentManager'
import { HOMEPAGE_CONFIG } from './homePage.config'

export default function useHomePageHeroVideoCldId() {
  const experimentManager = useExperimentManager()
  const isMediumScreen = useScreenSize('md')
  const isChristmas = experimentManager.isEnabled('christmas')

  return useMemo(() => {
    if (isChristmas) {
      return isMediumScreen
        ? 'assets/homepage/christmasDesktop'
        : 'assets/homepage/christmasMobile'
    }
    if (
      !isMediumScreen &&
      experimentManager.isEnabled('stacey-solomon-homepage-hero')
    ) {
      return 'assets/homepage/stacey-solomon/stacey-solomon-hero'
    }
    if (
      !isMediumScreen &&
      experimentManager.isEnabled('tammin-sursok-homepage-hero')
    ) {
      return 'assets/homepage/tammin-sursok/tammin-sursok-hero'
    }

    return isMediumScreen
      ? HOMEPAGE_CONFIG.heroVideo.desktop
      : HOMEPAGE_CONFIG.heroVideo.mobile
  }, [isMediumScreen, isChristmas, experimentManager])
}
